<template>
  <section v-if="identities" class="admin-wechat">
    <p v-if="!identities.length" class="admin-note">{{ t('admin-wechat-none') }}</p>
    <table v-else>
      <tr><th>{{ t('admin-col-name') }}</th><th>openid</th><th v-if="spares.length">{{ t('admin-notify-template') }}</th><th></th></tr>
      <tr v-for="i in identities" :key="i.openId" :data-user="i.user.id">
        <td class="name">{{ i.user.displayName }}</td>
        <td class="mail">{{ i.openId }}</td>
        <td v-if="spares.length" class="template">
          <select :value="i.notifyTemplate" name="notifyTemplate" :aria-label="t('admin-notify-template')" @change="setTemplate(i, $event.target.value)">
            <option value="">{{ t('admin-notify-template-default') }}</option>
            <option v-for="id in spares" :key="id" :value="id">…{{ id.slice(-6) }}</option>
          </select>
        </td>
        <td class="acts">
          <span v-if="confirming === i.openId" class="inline">
            {{ t('admin-wechat-unlink-confirm', { name: i.user.displayName }) }}
            <template v-if="!emails[i.user.id]">{{ t('admin-wechat-unlink-warning') }}</template>
            <button type="button" @click="unlink(i)">{{ t('button-confirm') }}</button>
            <button type="button" @click="confirming = null">{{ t('dialog-cancel') }}</button>
          </span>
          <button v-else type="button" @click="confirming = i.openId">{{ t('admin-unlink-wechat') }}</button>
        </td>
      </tr>
    </table>
    <p v-if="message" :class="message.cls">{{ message.text }}</p>
  </section>
</template>

<script>
// The WeChat module's section of the admin page: unlinking accounts from their WeChat, and giving a
// player a spare notification template (WECHAT_NOTIFY_SPARE_<n>_TEMPLATE_ID) when WeChat remembers
// their rejection of the default one. A change asks that player again with the reminder notice.
import { t, errorText } from '@/texts';
import { adminCall, onAdminChange, adminChanged } from '@/admin';

export default {
  name: 'WeChatAdminSection',
  data() {
    return { identities: null, emails: {}, confirming: null, message: null, spares: [] };
  },
  async created() {
    try {
      this.spares = (await adminCall('GET', 'wechat')).notifySpareTemplateIds || [];   // only when WeChat is set up
    } catch (e) {
      return;
    }
    this.stop = onAdminChange(this.load);
    await this.load();
  },
  beforeDestroy() {
    if (this.stop) this.stop();
  },
  methods: {
    t,
    async load() {
      const [identities, users] = await Promise.all([adminCall('GET', 'wechat/identities'), adminCall('GET', 'users')]);
      this.emails = Object.fromEntries(users.map(u => [u.id, u.email || '']));
      this.identities = identities;
      this.$emit('count', identities.length);
    },
    async setTemplate(i, notifyTemplate) {
      try {
        await adminCall('PATCH', `wechat/identities/${encodeURIComponent(i.openId)}`, { notifyTemplate });
        await this.load();
        adminChanged(this.load);
        this.message = { cls: 'info', text: t('admin-saved') };
      } catch (e) {
        this.message = { cls: 'warn', text: errorText(e.msg || String(e)) };
        await this.load();
      }
    },
    async unlink(i) {
      try {
        await adminCall('DELETE', `wechat/identities/${encodeURIComponent(i.openId)}`);
        this.confirming = null;
        await this.load();
        adminChanged(this.load);
        this.message = { cls: 'info', text: t('admin-saved') };
      } catch (e) {
        this.message = { cls: 'warn', text: errorText(e.msg || String(e)) };
      }
    },
  },
};
</script>
